<template>
  <div>
    {{isPathChanged}}
    <v-row
    v-if="isDataReady"
    dense
    no-gutters>
      <v-col :class="`d-flex justify-center align-center ${dialog ? '' : 'pt-10'}`">
        <v-card
        width="460"
        class="rounded-0 primary-background-color"
        elevation="5">
          <v-row
          dense
          no-gutters>
            <v-col>
              <div class="new-part-title-box d-flex justify-center align-center">
                <span v-if="isCreating">{{$t('pages.part.addPart')}}</span>
                <span v-else>{{$t('pages.part.editPart')}}</span>
              </div>
            </v-col>
          </v-row>
          <v-form 
          ref="form"
          v-model="isFormValidated">
            <v-row
            v-if="!dialog"
            dense
            no-gutters
            class="px-4">
              <v-col
              class="d-flex justify-end">
                <text-field-switch
                v-model="newPart.enabled"
                label="textFields.enabledDisabled"
                required/>
              </v-col>
            </v-row>
           <v-row dense no-gutters class="px-4 mt-6">
            <v-col>
              <part-category-autocomplete
              v-model="newPart.category"
              :label="$t('textFields.selectCategory')"
              required
              />
            </v-col>
          </v-row>
          <v-row dense no-gutters class="px-4 my-4">
            <v-col>
              <text-field-value
              v-model="newPart.number"
              :label="$t('textFields.partNumber')"
              required/>
            </v-col>
          </v-row>
          <v-row dense no-gutters class="px-4 my-4">
            <v-col>
              <text-field-value
              v-model="newPart.model"
              :label="$t('textFields.partModel')"
              required/>
            </v-col>
          </v-row>
          <v-row dense no-gutters class="px-4 my-4">
            <v-col>
              <text-field-value
              v-model="newPart.manufacturer"
              :label="$t('textFields.manufacturer')"
              required/>
            </v-col>
          </v-row>
          <v-row dense no-gutters class="px-4 my-4 mt-6">
            <v-col>
              <text-area
              v-model="newPart.description"
              :label="$t('textFields.shortDescription')"
              no-resize
              required/>
            </v-col>
          </v-row>
          <v-row dense no-gutters class="px-4 my-4">
            <v-col>
              <text-field-file
              id="input-part-file"
              :label="$t('textFields.uploadYourFile')"
              accept="image/*"
              @input="onFileSelected"/>
            </v-col>
          </v-row>
          <div class="d-flex justify-center px-4 my-4">
            <img
            v-if="newPart.imageUrl"
            :src="newPart.imageUrl"
            class="img-thumbnail"
            />
          </div>
          <v-row dense no-gutters class="px-4 my-4 mt-6">
            <v-col>
              <text-field-autocomplete-chips
              v-model="newPart.serviceCategories"
              :label="$t('textFields.serviceCategories')"
              :items="allServiceCategories"
              item-value="id"
              item-text="key"
              />
            </v-col>
          </v-row>
          <v-row
          v-if="!isCreating"
          dense
          no-gutters
          class="px-4 my4 mt-6">
            <v-col class="d-flex justify-center">
              <select-predefined-services-dialog
              v-if="predefinedServicesDialog.model"
              v-model="predefinedServicesDialog.model"
              :services-for-diagnostics="predefinedServicesDialog.forDiagnostics"
              :services-for-repair="predefinedServicesDialog.forRepair"
              :services-for-parts="predefinedServicesDialog.forParts"/>

              <icon-button
              @click="openPredefinedServicesDialog"
              src="list-box"
              color="blue"/>
            </v-col>
          </v-row>
          <div 
          class="my-8"
          style="width: 100%; height: 1px; background-color: rgba(0,0,0,.2);"/>
         </v-form>
          <v-row 
          dense 
          no-gutters 
          justify="center"
          class="px-4 pb-4">
            <v-col 
            v-if="!isCreating" 
            cols="6"
            class="d-flex justify-center align-center">
              <primary-btn
              @click="routeTo('parts')"
              color="#00bcd4"
              :label="$t('btns.backToList')"
              :width="180"
              :height="50"/>
            </v-col>
            <v-col 
            :cols="isCreating ? 12 : 3"
            class="d-flex justify-center align-center">
              <primary-btn
              @click="isCreating ? tryToSaveData() : setChangedDialogItems()"
              :disabled="!isFormValidated || newPart.image === null"
              :label="$t('btns.save')"
              :loading="isLoading"
              color="#4285f4"
              :width="100"
              :height="50"/>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import TextFieldSwitch from '@/components/text-fields/TextFieldSwitch'
import TextFieldValue from '@/components/text-fields/TextFieldValue'
import TextArea from '@/components/text-fields/TextArea'
import TextFieldFile from '@/components/text-fields/TextFieldFile'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import TextFieldAutocompleteChips from '@/components/text-fields/TextFieldAutocompleteChips'
import SelectPredefinedServicesDialog from '@/components/dialogs/SelectPredefinedServicesDialog'
import IconButton from '@/components/btns/IconButton'
import PartCategoryAutocomplete from '@/components/text-fields/PartCategoryAutocomplete'
import { routeFromRoot } from '@/services/routeService'
import { fetchPart, savePart } from '@/repositories/partRepo'
import { execHttpRequestThrowable } from '@/services/http'
import { getUserIdentification } from '@/services/authService'
import { fetchServiceCategoriesByKeys } from '@/repositories/serviceCategoryRepo'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
// compareObjects
import { cloneObj, copyObj } from '@/utils/StringUtil'
import { getFileAsBase64 } from '@/utils/FileUtil'
import { getObjectPartCategoryByKey } from '@/utils/statusesUtil'

export default {
  components: {
    TextFieldAutocompleteChips,
    TextFieldSwitch,
    TextFieldValue,
    TextArea,
    TextFieldFile,
    PrimaryBtn,
    SelectPredefinedServicesDialog,
    IconButton,
    PartCategoryAutocomplete
  },
  props: {
    dialog: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      isFormValidated: false,
      allServiceCategories: [],
      currentPath: '',
      isCreating: false,
      oldPart: null,
      newPart: null,
      isLoading: false,
      isDataReady: false,
      predefinedServicesDialog: {
        model: false,
        forDiagnostics: [],
        forRepair: [],
        forParts: []
      }
    }
  },
  computed: {
    isPathChanged() {
      if (this.currentPath !== this.$route.path) this.setCurrentPath()
      return ''
    }
  },
  methods: {
    async tryToSaveData() {
      const isEdit = !this.isCreating
      const body = {
        id: isEdit ? this.$route.params.id : -1,
        category: this.newPart.category.key,
        number: this.newPart.number,
        model: this.newPart.model,
        manufacturer: this.newPart.manufacturer,
        description: this.newPart.description,
        enabled: this.dialog ? true : this.newPart.enabled,
        serviceCategories: this.newPart.serviceCategories,
        identificator: this.dialog ? getUserIdentification() : null,
        image: this.newPart.image
      }
      // console.log(body)
      const r = await execHttpRequestThrowable(async () => await savePart(body), {}, v => this.isLoading = v)
      if (isEdit) {
        // NOTE: nulled, so the image can be marked as old
        this.newPart.image.base64 = null
        cloneObj(this.newPart, this.oldPart)
        this.openSuccessDialog(this.$t('dialogs.messages.success.partSavedSuccessfully'))
      }
      else {
        if (this.dialog) this.$emit('part', r.response.data)
        else routeFromRoot('parts')
      }
    },
    async tryToFetchServiceCategoriesByKeys() {
      const r = await execHttpRequestThrowable(async () => await fetchServiceCategoriesByKeys(['REPAIR', 'PARTS']))
      this.allServiceCategories = r.response.data
    },
    async setChangedDialogItems() {
      this.tryToSaveData()  
      // NOTE: ENABLE_CHANGE_DIALOG - Enable this code, if changes dialog is needed.
      // const old = this.oldPart
      // const _new = this.newPart

      // const props = [
      //   {
      //     field: 'textFields.selectCategory',
      //     prop: 'category.name'
      //   }, {
      //     field: 'textFields.partNumber',
      //     prop: 'number'
      //   }, {
      //     field: 'textFields.partModel',
      //     prop: 'model'
      //   }, {
      //     field: 'textFields.manufacturer',
      //     prop: 'manufacturer'
      //   }, {
      //     field: 'textFields.shortDescription',
      //     prop: 'description'
      //   }, {
      //     field: 'textFields.enabledDisabled',
      //     prop: 'enabled',
      //     getter: (s) => this.$t(`textFields.${s ? 'enabled' : 'disabled'}`)
      //   }, {
      //     field: {
      //       value: 'textFields.serviceCategories',
      //       params: null
      //     },
      //     prop: 'serviceCategories[].key'
      //   }, {
      //     field: 'textFields.uploadYourFile',
      //     prop: 'image.base64'
      //   },
      // ]
      // this.$changesDialog.open(
      //   'dialogs.titles.changes',
      //   compareObjects(old, _new, props),
      //   this.tryToSaveData,
      //   false
      // )
      //-----------------------------------------------------------------
    },
    async tryToFetchPart() {
      const r = await execHttpRequestThrowable(async () => await fetchPart(this.$route.params.id), {}, v => this.isLoading = v)
      const p = r.response.data
      this.oldPart = copyObj(p)
      
      this.oldPart.category = getObjectPartCategoryByKey(p.category)
      this.newPart = copyObj(this.oldPart)
    },
    async onFileSelected(files) {
      if (files === null || files.legnth === 0) return
      const f = files[0]
      this.newPart.image = {
        name: f.name,
        size: f.size,
        type: f.type,
        base64: await getFileAsBase64(f)
      }
      this.newPart.imageUrl = this.newPart.image.base64
    },
    async setCurrentPath() {
      this.currentPath = this.$route.path
      if (this.$route.params.id) {
        this.isCreating = false
        await this.tryToFetchPart()
      }
      else {
        this.isCreating = true
        this.newPart = {
          id: null,
          image: null,
          imageUrl: "",
          category: null,
          number: '',
          model: '',
          manufacturer: '',
          description: '',
          serviceCategories: [],
          enabled: this.dialog
        }
        if (this.$refs.form) this.$refs.form.resetValidation()
      }

      this.isDataReady = true
    },
    openPredefinedServicesDialog() {
      this.predefinedServicesDialog = {
        model: true,
        forDiagnostics: this.newPart.predefinedServicesForDiagnostics,
        forRepair: this.newPart.predefinedServicesForRepairs,
        forParts: this.newPart.predefinedServicesForParts,
      }
    },
    openSuccessDialog(m) {
      this.$successDialog.open(null, m, null)
    },
    routeTo(link) {
      routeFromRoot(link)
    }
  },
  async mounted() {
    await this.tryToFetchServiceCategoriesByKeys()
  },
  created() {
    this.$feedback.fill("Process Part Page", this.$route.path)
  }
}
</script>
<style>
.new-part-title-box {
  width: 100%;
  height: 50px;
  color: white;
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
  font-size: 1.2rem;
  letter-spacing: 1px;
  background-color: #0277bd!important;
  background: linear-gradient(40deg,#45cafc,#303f9f)!important;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  width: 100%;
  height: auto;
}
</style>